
import React, { useState } from "react";
import "../../styles/Services.css";
import { FaMinus, FaPlus } from "react-icons/fa";
import { RiArrowRightSLine } from "react-icons/ri";
import Application_bg_img from "../../bg_images/S_app_bg_img.png";
import { useNavigate } from "react-router-dom";
import { HiArrowNarrowRight } from "react-icons/hi";


const Servicesfaqs = [
  {
    question: " What is augmentation in the workplace? ",
    answer:
      "Augmentation in the workplace refers to the addition of external resources or tools to enhance existing capabilities, increase productivity, and support the execution of specific tasks or projects.",
  },
  {
    question: " What is team augmentation? ",
    answer:
      " Team augmentation is the process of temporarily expanding a team’s workforce by integrating external resources, such as developers, designers, or project managers, into an existing team to accelerate project completion and improve productivity. ",
  },
  {
    question: " What is another word for staff augmentation? ",
    answer:
      " synonym for staff augmentation is resource augmentation or talent augmentation ",
  },
  {
    question: " What is staff augmentation vs. outsourcing? ",
    answer:
      " Staff augmentation involves adding external resources to work as part of your team, while outsourcing means hiring a third-party company to handle all aspects of a project. The main difference lies in the level of control you have over the project and the integration of resources into your team. ",
  },
];

const StaffAugumentation = () => {
    const navigate = useNavigate();
  
  const [ServicesopenIndex, ServicessetOpenIndex] = useState(null); // Removed `number | null`

  const handleToggle = (index) => {
    ServicessetOpenIndex(ServicesopenIndex === index ? null : index);
  };

  return (
    <div className="Service_Container">
      {/* Cousals end */}

      <div
        className="Service_sec1"
        style={{
          backgroundImage: `url(${Application_bg_img})`,
          backgroundSize: "cover",
          backgroundPosition: "center",
          backgroundRepeat: "no-repeat",
          width: "98.5vw",
        }}
      >
        <section className="Service_sec1_one">
          <h5>
            Services{" "}
            <span>
              <RiArrowRightSLine className="servrighticon" />
            </span>
            Staff Augumentation
          </h5>
          <h2> Scale Your Team, Accelerate Your Success </h2>
          <p>
            With Arshil’s staff augmentation services, you can augment your
            technology team with experienced professionals specific to your
            project needs.
          </p>
          <button onClick={() => navigate("/contact")} className="S_sec1_btn1">
            Talk to an Expert
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>

      {/* Sec 2  */}

      <div className="Service_sec2">
        <section className="Service_sec2_in1">
          <h2>What we Offer as a Staff Augumentation Company</h2>
          <section className="Service_sec2_in1_h4C">
            <section>
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img1.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Web app development / developers:
                </span>{" "}
                Frontend and backend experts to create robust web applications.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img2.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Mobile app development / developers:
                </span>{" "}
                Skilled engineers to build and maintain apps on Android and iOS.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img3.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Full-Stack Developers:
                </span>{" "}
                Professionals who work on both the frontend and backend
                development.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2-img4.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  QA Testers and Analysts:
                </span>{" "}
                Ensure your applications are reliable and ready for deployment.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img5.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  Project Managers and Scrum Masters:
                </span>{" "}
                Experienced leaders to keep your projects on track and boost
                team productivity.
              </h4>
            </section>
          </section>
          <section className="Service_sec2_in1_h4C">
            <section>
              {" "}
              <img
                className="Service_sec3_img1"
                src="../images/s_sec2_img6.png"
                alt=""
              />
            </section>

            <section>
              <h4 className="Service_sec2_in1_h4C_container">
                <span className="Service_sec2_in1_h4C_container_span">
                  UI/UX Designers:
                </span>{" "}
                Creative professionals who help craft intuitive and engaging
                user experiences.
              </h4>
            </section>
          </section>

          <section>
            <button
              onClick={() => navigate("/contact")}
              className="Service_sec2_in1_button"
            >
              Get a Free Quote
              <HiArrowNarrowRight className="s_sec2demoarrow" />
            </button>
          </section>
        </section>

        <section>
          <img className="s_sec2_img1" src="../images/S_staff_Agu.png" alt="" />
        </section>
      </div>

      {/* Sec 3 */}
      <div className="Service_sec3">
        <section className="Service_sec3_one">
          <h2>Why Choose Arshil for Staff Augumentation </h2>
          <p>
            At Arshil, we provide flexible staff augmentation services tailored
            to your specific business needs. Our approach allows you to expand
            your team with dedicated developers, designers, project managers, or
            testers without the burden of long-term commitments or training new
            hires. Here’s why you should choose Arshil:
          </p>
        </section>

        <section className="Service_sec3_two">
          <section className="Service_sec3_two_in1">
            <img src="../images/s_sa_sec3_img1.png" alt="" />
            <h5> Flexibilty </h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_sa_sec3_img2.png" alt="" />
            <h5> Cost - effective </h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_sa_sec3_img3.png" alt="" />
            <h5> Access to Top Talent </h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_sa_sec3_img4.png" alt="" />
            <h5> Enhanced Productivity </h5>
          </section>
          <section className="Service_sec3_two_in1">
            <img src="../images/s_sa_sec3_img5.png" alt="" />
            <h5> Knowledge Transfer </h5>
          </section>

          <section className="Service_sec3_two_in1">
            <img src="../images/s_sa_sec3_img6.png" alt="" />
            <h5> Customer - Centric </h5>
          </section>
        </section>
      </div>

      {/* sec 4  */}

      <div className="Service_sec4">
        <h1> Our Approach to Staff Augumentation </h1>
        <p>
          {" "}
          Arshil’s staff augmentation services include two distinct models, Fish
          Bowl and Swim Together, each designed to deliver unique benefits to
          your business:
        </p>
        <ul className="Service_sec4_ul">
          <li> Autonomous Delivery </li>
          <p>
            Arshil works independently on your project. You can observe our
            streamlined processes and advanced technologies while remaining
            separate from our team. This model allows for faster delivery with
            high quality, without requiring direct client engagement.
          </p>
          <li> Integrated Delivery </li>
          <p>
            Arshil collaborates closely with your team. Our developers,
            designers, and project managers join your staff to work side-by-side
            on project deliverables. This approach enhances knowledge transfer
            and boosts your team’s capabilities, though delivery times may be
            slightly extended to accommodate team learning.
          </p>
        </ul>
      </div>

      {/* Sec 5 */}

      <section className="Service_sec5_in1_FaQ">
        <h1 className="Service_sec5_in1_FaQ_h1">
          Frequently Asked Questions (FAQs)
        </h1>
        {Servicesfaqs.map((faq, index) => (
          <div key={index} className="Service_sec5_in1_FaQ-in1">
            <div className="faq-header" onClick={() => handleToggle(index)}>
              <h5>{faq.question}</h5>
              <span className="icon">
                {ServicesopenIndex === index ? <FaMinus /> : <FaPlus />}
              </span>
            </div>
            {ServicesopenIndex === index && (
              <p className="faq-answer">{faq.answer}</p>
            )}
          </div>
        ))}
      </section>

      <div className="Sec8_container">
        <section>
          <h1> Ready to Scale Your Team? </h1>
          <p>
            Arshil’s staff augmentation services provide the flexibility and
            expertise you need to drive projects forward, reduce costs, and
            maintain control over your core operations. Reach out to us today to
            discuss your specific needs and find the right talent to support
            your growth.
          </p>
        </section>

        <section className="Sec8_container_button">
          <button onClick={() => navigate("/contact")}>
            Talk to an Expert
            <HiArrowNarrowRight className="psec1arrow" />
          </button>
        </section>
      </div>
    </div>
  );
};

export default StaffAugumentation;



